/* ============================================================
   Andes — Reveal al scroll de las secciones del HOME.
   Las secciones aparecen (fade + leve subida) al entrar en viewport,
   en vez de "ya estar". Nivel premium, sobrio.
   Sin flash: solo marcamos [data-andes-reveal] (estado oculto) en las
   secciones que están BAJO el pliegue; las visibles al cargar se muestran
   de inmediato. Respeta prefers-reduced-motion (no oculta nada).
   Plain JS, sin dependencias.
   ============================================================ */
(function () {
  var main = document.getElementById('MainContent');
  if (!main) return;

  // Solo en la home (template "index").
  var tpl = main.getAttribute('data-template') || '';
  if (tpl.indexOf('index') !== 0) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function run() {
    var sections = main.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -6% 0px' }
    );

    var vh = window.innerHeight || 800;

    sections.forEach(function (section, index) {
      if (section.hasAttribute('data-andes-reveal')) return;
      section.setAttribute('data-andes-reveal', '');

      var top = section.getBoundingClientRect().top;
      // La primera (hero) y todo lo que ya se ve al cargar → visible de una (sin flash).
      if (index === 0 || top < vh * 0.88) {
        section.classList.add('is-visible');
      } else {
        io.observe(section);
      }
    });
  }

  if (document.readyState !== 'loading') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
})();
